'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _flatten = require('lodash/array/flatten');

var _flatten2 = _interopRequireDefault(_flatten);

var _pairs = require('lodash/object/pairs');

var _pairs2 = _interopRequireDefault(_pairs);

var _map = require('lodash/collection/map');

var _map2 = _interopRequireDefault(_map);

var _flow = require('lodash/function/flow');

var _flow2 = _interopRequireDefault(_flow);

var _kebabCase = require('lodash/string/kebabCase');

var _kebabCase2 = _interopRequireDefault(_kebabCase);

var _get = require('lodash/object/get');

var _get2 = _interopRequireDefault(_get);

var _pick = require('lodash/object/pick');

var _pick2 = _interopRequireDefault(_pick);

var _normalize = require('./normalize');

var _normalize2 = _interopRequireDefault(_normalize);

var _negate = require('lodash/function/negate');

var _negate2 = _interopRequireDefault(_negate);

var _propTypes2 = require('./prop-types');

var _propTypes3 = _interopRequireDefault(_propTypes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var pickBy = function pickBy(fn) {
    return function (obj) {
        return (0, _pick2['default'])(obj, fn);
    };
};
var mapWith = function mapWith(fn) {
    return function (coll) {
        return (0, _map2['default'])(coll, fn);
    };
};

var isStyleProp = function isStyleProp(_, key) {
    return _propTypes3['default'][key];
};
var isNotStyleProp = (0, _negate2['default'])(isStyleProp);

/**
 * Takes the rule name, value, and an optional prefix and constructs the correct
 * classname.  That classname is used to lookup the runtime classname via CSS
 * Modules.
 *
 * @example
 * const config = {
 *      breakpoints: ['m', 'l'],
 *      styles: {
 *          'display-block': 'display-block-hashed-by-css-modules'
 *      }
 * };
 * const converted = makeConvertStyleToClassName(config);
 * const className = convertStylesToClassName('display', 'block');
 * //=> styles['display-block']
 * //=> display-block-hashed-by-css-modules
 */
var makeConvertStyleToClassName = function makeConvertStyleToClassName(config) {
    return function (ruleName, ruleValue, prefix) {
        var rule = (0, _kebabCase2['default'])(ruleName + '-' + ruleValue);
        var prefixedRule = prefix ? prefix + '-' + rule : rule;
        var className = (0, _get2['default'])(config.styles, prefixedRule, '');

        return className;
    };
};

/**
 * This function converts understyles's inline styles to CSS classes.  We take
 * the style rules and create rule name out of them.  So, { flexDirection: 'row'
 * } becomes the string 'flex-direction-row'.  We take that rule name and get
 * the associated classname via the CSS module lookup.
 *
 * @param {Object} config - The config object
 * @return {Function} A function that takes in an array of style objects
 *
 * @example
 * const config = {
 *      breakpoints: ['m', 'l'],
 *      styles: {
 *          'display-block': 'display-block-hashed-by-css-modules'
 *      }
 * };
 * const converter = convertStylesToClassName(config);
 * const styles = [{ property: 'display', value: 'block' }];
 * const result = converter(styles);
 * //=> ['display-block-hashed-by-css-modules']
 */
function makeConvertStylesToClassName(config) {
    var convertStyleToClassName = makeConvertStyleToClassName(config);
    var breakpoints = [''].concat(_toConsumableArray(config.breakpointPrefixes));

    /**
     * A function that takes in an array of style objects.
     * @param {Array<{ property: string, value: (number|string) }>}
     * @return {Array<string>}
     */
    return mapWith(function (rule) {
        if (!rule) return;

        var property = rule.property,
            value = rule.value;


        if (Array.isArray(value)) {
            return value.map(function (val, idx) {
                return convertStyleToClassName(property, val, breakpoints[idx]);
            });
        }

        return convertStyleToClassName(property, value);
    });
}

/**
 * Takes a config and a props object, picks off any of the defined style props,
 * and returns the correct classname for the combined style props.
 *
 * @param {Object} config - See config file for types
 * @param {Object} props - The props object
 * @return {Object} result - Tuple of class name and filtered props
 * @return {string} result.className - The resulting class name
 * @return {Object} result.props - The filtered props
 *
 * @example
 * const config = {
 *      breakpoints: ['m', 'l'],
 *      styles: {
 *          'display-block': 'display-block-hashed-by-css-modules'
 *      }
 * };
 * const parser = parseProps(config);
 * const myProps = { display: 'block', someOtherProp: true };
 * const { props, className } = parser(myProps);
 *
 * console.log(props);
 * //=> { someOtherProps: true; }
 *
 * console.log(className);
 * //=> 'display-block-hashed-by-css-modules'
 */
var parseProps = function parseProps(config) {
    return function (props) {
        var pipeline = (0, _flow2['default'])(pickBy(isStyleProp), _pairs2['default'], mapWith((0, _normalize2['default'])(config)), _flatten2['default'], makeConvertStylesToClassName(config));

        var className = (0, _classnames2['default'])(props.className, pipeline(props));
        var filteredProps = (0, _pick2['default'])(props, isNotStyleProp);

        return {
            className: className,
            props: filteredProps
        };
    };
};

exports['default'] = parseProps;


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/blocks/lib/parse-props.js
 ** module id = 332
 ** module chunks = 0 1
 **/